import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AppContext, SeoService } from './../../shared';
import { BlogPage } from  './../blog-page';

@Component({
  selector: 'linescape-vessel-information-anniversary',
  template: require('./linescape-vessel-information-anniversary.component.html'),
  styles: [require('./../blog.component.scss'), require('./linescape-vessel-information-anniversary.component.scss')]
})
export class LinescapeVesselInformationAnniversaryComponent extends BlogPage {
  title = "Linescape celebrates 2nd Anniversary with Vessel Information - Linescape";
  description = "Sailing Schedules Website Expands Results to Display Vessel Register Data.";

  constructor(route: ActivatedRoute, app: AppContext, seo: SeoService) {
    super(route, app, seo);
  }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/press/linescape-vessel-information-anniversary/linescape-vessel-information-anniversary.component.ts